<template>

    <div>

        <h2 class="section-title">Über mich</h2>

        <div class="row mt-4 align-items-start">

            <div class="col-12 col-md-3 text-center mb-4 mb-md-0">

                <img
                    src="@/assets/me.jpg"
                    class="img-fluid about-photo"
                    alt="Daniel Wiesner"
                >

                <div class="about-name mt-3">Daniel Wiesner</div>
                <div class="about-title">Elektrobetriebstechniker<br>Automatisierungstechniker</div>

            </div>

            <div class="col-12 col-md-9">

                <p class="about-intro">
                    Gelernter Elektrobetriebstechniker und Automatisierungstechniker aus
                    St. Radegund (Oberösterreich). Zur IT bin ich über meine früheren
                    Arbeitgeber gekommen. Dort habe ich die IT-Betreuung übernommen,
                    bin dabei geblieben und habe sie in weiteren Unternehmen fortgeführt.
                </p>

                <p class="about-intro mt-3">
                    Da moderne Automatisierungstechnik zunehmend Netzwerkkenntnisse und
                    IT-Sicherheit voraussetzt, ist mein Interesse in diese Richtung
                    gewachsen. Durch viel Selbststudium und gezielte Online-Fortbildungen
                    habe ich mir dieses Wissen systematisch erarbeitet. Seit über fünf
                    Jahren bin ich mit WIESNERD selbständig und betreue echte Systeme
                    in produktiven Umgebungen.
                </p>


            </div>

        </div>

    </div>

</template>

<script>

    export default {

        name: 'TheAboutMeComponent',

    }

</script>

<style scoped>

    .about-photo {

        max-width: 180px;
        border-radius: 8px;
        border: 2px solid rgba(11, 95, 165, 0.15);

    }

    .about-name {

        font-weight: 700;
        font-size: 1rem;
        color: #1a2a3a;

    }

    .about-title {

        font-size: 0.8rem;
        color: #7a8a9a;
        line-height: 1.5;
        margin-top: 0.25rem;

    }

    .about-intro {

        color: #4a5a6a;
        line-height: 1.7;
        margin-bottom: 0;

    }


</style>
